import React, { useEffect, useState } from "react";
import { Link } from "gatsby"
import PlayVideo from "../../modules/video_module/PlayVideo";
import { PageLinks } from "../../common/page-links";
import ImageModule from "../../modules/image_module";

import _ from "lodash";

const NewsCard = ({ item, imagename }) => {

    let [isPlay, setPlay] = React.useState(false);
    let [videoUrl, setVideoUrl] = React.useState(null); 

    const ImageRenderList = ({ item, imagename }) => {
        let processedImages = JSON.stringify({});
        if (item?.imagetransforms?.tile_image_Transforms) {
            processedImages = item?.imagetransforms?.tile_image_Transforms;
        }

        return (
            <ImageModule ImageSrc={item.tile_image} title={item.title} altText={item.title} imagetransforms={processedImages} renderer="srcSet" imagename={imagename} strapi_id={item.id} />
        )
    }


    return (
        <>

            <div className="card-wrap">
                <div className="card-img">
                    <Link to={`/${PageLinks.news_insight}/${item.slug}/`}>
                        <ImageRenderList item={item} imagename={imagename} />
                    </Link>
                </div>
                {
                    item.embed_video_url && <button className="video-wrap" onClick={e => {
                        setVideoUrl(item.embed_video_url)
                        setPlay(true)
                    }}>
                        <i className="icon-video"></i>
                    </button>
                }
                {
                    item.tags ? <Link to={`/${PageLinks.news_insight}/${item.slug}/`} className="top-info">
                        <span className="text">
                            {item.tags}</span>
                    </Link> : ''
                }
                <div className="card-text">
                    <h3><Link to={`/${PageLinks.news_insight}/${item.slug}/`}>{item.title}</Link></h3>
                    <Link to={`/${PageLinks.news_insight}/${item.slug}/`} className="view">View Blog</Link>
                </div>
            </div>
            
            <PlayVideo
                isOpen={isPlay}
                isCloseFunction={setPlay}
                videoUrl={videoUrl}
                isAutoPlay={1}
            />
        </>
    );
};
export default NewsCard;
